import React from 'react';
import axios from "axios";
import ContactinfoList from './ContactinfoList';
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import NavFormProfile from './NavFormProfile';
import AdminNavFormProfile from './AdminNavFormProfile';


import Path from "./config";
class ContactInfo extends React.Component {
    constructor(props) {
        super(props);
        //for radio onchange
        //this.showScanType = this.showScanType.bind(this);

        this.state = {
            relationWith: [],
            sbgr_person_name: '',
            sbgr_bride_groom_relation: '',
            sbgr_Mobile_no1: '',
            sbgr_Mobile_no2: '',
            sbgr_address: '',
            sbg_list: [],
            btn_show: true,
            update_btn: false,
            sbgr_id: '',
            next_btn: false,
            prifixList: [],
            mobile1: "0",
            mobile2: "0",
            NavMenu: false,
            sbgr_prifix: ''

        }
    }
    nameHandler = (e) => {
        document.getElementById("sbgr_person_name").style.borderColor = "";


        let data = e.target.value;
        if (data.length > 60) {

        } else {
            this.setState
                ({ sbgr_person_name: e.target.value })
        }
    }

    relationHandler = (e) => {
        document.getElementById("sbgr_bride_groom_relation").style.borderColor = "";
        this.setState({ sbgr_bride_groom_relation: e.target.value });
    }

    mobHandler = (e) => {
        document.getElementById("sbgr_Mobile_no1").style.borderColor = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbgr_Mobile_no1: e.target.value }, () => {
                this.setState({ mobile1: this.state.sbgr_Mobile_no1.length })

            })
        }

    }

    phoneHandler = (e) => {
        document.getElementById("mobile2").style.borderColor = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbgr_Mobile_no2: e.target.value }, () => {
                this.setState({ mobile2: this.state.sbgr_Mobile_no2.length })

            })
        }

    }

    addressHandler = (e) => {
        document.getElementById("sbgr_address").style.borderColor = "";

        let data = e.target.value;
        if (data.length > 30) {

        } else {
            this.setState
                ({ sbgr_address: e.target.value })
        }
    }

    prifixHandler = (e) => {
        document.getElementById("sbgr_prifix").style.borderColor = "";
        this.setState({ sbgr_prifix: e.target.value });
    }


    componentDidMount() {
        // console.log("sbsbsbsbsbsbsbs",this.props.match.params.sbgr_id)

        this.setState({
            userId: localStorage.getItem("userId"),
            sbgr_id: this.props.match.params.sbgr_id,
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")

        })
        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }
        // ********************** relationWith ************************
        axios.get(Path + 'relation_with_bridge_groom.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ relationWith: response.data.relation_with_bridge_groom })
            }.bind(this))


        this.showCountRel();

        this.showList();

        axios.get(Path + 'Suchi_bride_groom_name_prifix.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ prifixList: response.data.prifix_list })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    }
    showList = () => {

        axios.get(Path + 'Suchi_bride_groom_relatives_view.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ sbg_list: response.data.relatives_list })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }

    showCountRel = () => {
        axios.get(Path + 'Suchi_bride_groom_countrel.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {


                if (response.data >= "2") {
                    this.setState({

                        next_btn: true,
                    })
                }
                if (response.data >= "3") {

                    this.setState({
                        btn_show: false,
                        update_btn: false,
                        next_btn: true
                    })

                }
                else {
                    this.setState({
                        btn_show: true,

                    })
                }
            }.bind(this))
    }
    showedit = (id) => {
        //console.log("iiiddddd",id)
        axios.get(Path + 'Show_bride_groom_vieweditrelation.php?sbgr_id=' + id)
            .then(function (response) {
                // handle success
                // console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;

                this.setState({
                    sbgr_id: id,
                    sbgr_person_name: response.sbgr_person_name,
                    sbgr_prifix: response.sbgr_prifix,
                    sbgr_bride_groom_relation: response.sbgr_bride_groom_relation,
                    sbgr_Mobile_no1: response.sbgr_Mobile_no1,
                    sbgr_Mobile_no2: response.sbgr_Mobile_no2,
                    sbgr_address: response.sbgr_address,
                    mobile1: response.sbgr_Mobile_no1.length


                })
            }.bind(this))

        if (id !== "") {
            this.setState({
                btn_show: false,
                update_btn: true
            })
        }

    }
    submitClick = (e) => {

        e.preventDefault();

        let isValid = true;


        if (this.state.sbgr_person_name === " ") {
            document.getElementById("sbgr_person_name").style.borderColor = "red";
            isValid = false;
        } else {
            const a = this.state.sbgr_person_name.split(' ');
            if (a.length < 4) {
                document.getElementById("sbgr_person_name").style.borderColor = "red";
                isValid = false;
            }

        }


        if (this.state.sbgr_Mobile_no1 === "") {
            document.getElementById("sbgr_Mobile_no1").style.borderColor = "red";
            isValid = false;
        }
        else if (this.state.mobile1 < 10) {
            isValid = false;
            document.getElementById("sbgr_Mobile_no1").style.borderColor = "red";
        }

        //  if(this.state.mobile2<10)
        // {
        //     isValid = false ;
        //     document.getElementById("mobile2").style.borderColor = "red";
        // }

        if (this.state.sbgr_address === "") {
            document.getElementById("sbgr_address").style.borderColor = "red";
            isValid = false;
        }

        //console.log("this.state.sbgr_prifix", this.state.sbgr_prifix)
        if (this.state.sbgr_prifix === "" || this.state.sbgr_prifix === "f") {
            document.getElementById("sbgr_prifix").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbgr_bride_groom_relation === "" || this.state.sbgr_bride_groom_relation === "f") {
            document.getElementById("sbgr_bride_groom_relation").style.borderColor = "red";
            isValid = false;
        }

        let tempStr = "sbgr_person_name=" + this.state.sbgr_person_name +
            "&sbgr_prifix=" + this.state.sbgr_prifix +
            "&sbgr_bride_groom_relation=" + this.state.sbgr_bride_groom_relation +
            "&sbgr_Mobile_no1=" + this.state.sbgr_Mobile_no1 +
            "&sbgr_Mobile_no2=" + this.state.sbgr_Mobile_no2 +
            "&sbgr_address=" + this.state.sbgr_address +
            "&sbg_id=" + this.state.userId
        //console.log(tempStr)
        if (isValid === true) {

            axios.post(Path + `Suchi_bride_groom_relatives_add.php?` + tempStr)
                .then(() => {
                    this.clearAll()
                    this.showList()
                    this.showCountRel()
                });
            this.setState({
                // next_btn:true

            })
            document.getElementById("error").innerHTML = "";
        }
        else { document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी."; }
    }

    updateClick = (e) => {
        e.preventDefault();
        e.preventDefault();

        let isValid = true;

        if (this.state.sbgr_person_name === "") {
            document.getElementById("sbgr_person_name").style.borderColor = "red";
            isValid = false;
        } else {
            const a = this.state.sbgr_person_name.split(' ');
            if (a.length < 4) {
                document.getElementById("sbgr_person_name").style.borderColor = "red";
                isValid = false;
            }

        }

        if (this.state.sbgr_prifix === "") {
            document.getElementById("sbgr_prifix").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbgr_Mobile_no1 === "") {
            document.getElementById("sbgr_Mobile_no1").style.borderColor = "red";
            isValid = false;
        }
        else if (this.state.mobile1 < 10) {
            isValid = false;
            document.getElementById("sbgr_Mobile_no1").style.borderColor = "red";
        }

        //  if(this.state.mobile2<10)
        // {
        //     isValid = false ;
        //     document.getElementById("mobile2").style.borderColor = "red";
        // }

        if (this.state.sbgr_address === "") {
            document.getElementById("sbgr_address").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbgr_bride_groom_relation === "" || this.state.sbgr_bride_groom_relation === "f") {
            document.getElementById("sbgr_bride_groom_relation").style.borderColor = "red";
            isValid = false;
        }

        let typee = "relative";

        let tempStr = "sbgr_person_name=" + this.state.sbgr_person_name +
            "&sbgr_prifix=" + this.state.sbgr_prifix +
            "&sbgr_bride_groom_relation=" + this.state.sbgr_bride_groom_relation +
            "&sbgr_Mobile_no1=" + this.state.sbgr_Mobile_no1 +
            "&sbgr_Mobile_no2=" + this.state.sbgr_Mobile_no2 +
            "&sbgr_address=" + this.state.sbgr_address +
            "&sbg_id=" + this.state.userId +
            "&sbgr_id=" + this.state.sbgr_id +
            "&type=" + typee
        // console.log(tempStr)
        if (isValid === true) {
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);


                    if (response.data.status === "updated") {
                        // localStorage.setItem("userId",response.data.sbg_id)
                        this.showList();

                        this.setState({
                            //btn_show:true,
                            update_btn: false,
                            next_btn: false
                        })

                    }
                    alert("Updated Successfully");
                    this.showCountRel();
                    this.clearAll();

                }.bind(this))
        }
        else { document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी."; }

    }

    clearAll = () => {

        this.setState({
            sbgr_id: "",
            sbgr_person_name: "",
            sbgr_prifix: "",
            sbgr_bride_groom_relation: "",
            sbgr_Mobile_no1: "",
            sbgr_Mobile_no2: "",
            sbgr_address: ""


        })
    }
    nextClick = (e) => {
        e.preventDefault();
        let typee = "relat";
        let tempStr = "&sbg_id=" + this.state.userId +
            "&type=" + typee
        axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
            .then(function (response) {
                if (response.data.status === "updated") {
                    if (this.state.admin === "Admin") {
                        this.props.history.push(`/AdminProfile/AssetInfo`);
                    } else {
                        this.props.history.push(`/FormProfile/AssetInfo`);
                    }
                }

                //alert("Updated Successfully");
            }.bind(this))
    }

    deleteshow = (id, count) => {


        if (count > 2) {
            axios.post(Path + `Show_bride_groom_deleterelation.php?id=` + id)
                .then(res => alert("Record Deleted")); this.showList(); this.showCountRel();

        }
        else {
            alert("Not Allowed")
        }
        this.showList();

    }
    render() {

        let prifix_Listm = this.state.prifixList.map((pr, index) => {
            const { pr_id, pr_name } = pr //destructuring
            return (

                <option key={pr_id} value={pr_id}> {pr_name} </option>

            )
        })


        let relationWithList = this.state.relationWith.map((relation, index) => {
            const { relation_id, relation_english } = relation //destructuring
            return (

                <option key={relation_id} value={relation_id}> {relation_english} </option>

            )
        })

        return (

            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className="m-5 pt-3" >
                    {/* <span className="pt-3 mx-auto" >वैयक्तिक माहिती </span> */}
                    <form className="row g-3">
                        <p className="text-primary" >
                            संपर्कासाठी पत्ते :-<br></br> <p>( टीप :- 1)  जवळीची ओळख निघण्यासाठी या संपर्काचा खूप फायदा होतो <br></br>
                                ( टीप :-2) यामध्ये आपण जास्तीत जास्त 3 ओळखीच्या व्यक्तींचे नावे देऊ शकता ,
                                कमीत कमी 2 व्यक्तींची नावे (आई वडिलांच्या व्यतिरिक्त) देणे आवश्यक आहे.</p>
                        </p>
                        <div className="col-md-6">
                            <label htmlFor="inputEmail4" className="form-label">* व्यक्तीचे संपूर्ण नाव    </label>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td width="20%">
                                            <select id="sbgr_prifix" value={this.state.sbgr_prifix} onChange={this.prifixHandler} className="date_combo form-select" style={{ width: "90%" }}>
                                                <option value="f">Select</option>
                                                {prifix_Listm}
                                            </select>
                                        </td>

                                        <td>
                                            <ReactTransliterate value={this.state.sbgr_person_name} maxLength="60" placeholder='व्यक्तीचे संपूर्ण नाव ' id="sbgr_person_name" onChange={this.nameHandler} className="form-control" required /></td>
                                    </tr>
                                </tbody>
                            </table>



                        </div>

                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label">* वधू वरसोबत असलेले नाते   </label>
                            <select id="sbgr_bride_groom_relation" value={this.state.sbgr_bride_groom_relation} maxLength="60" onChange={this.relationHandler} className="form-select">
                                <option value="f">Choose...</option>
                                {relationWithList}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label">* मोबाइल नंबर 1    </label>
                            <input type="text" value={this.state.sbgr_Mobile_no1} minLength="10" maxLength="13" onChange={this.mobHandler} id="sbgr_Mobile_no1" className="form-control" />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label">मोबाइल नंबर 2   </label>
                            <input type="text" value={this.state.sbgr_Mobile_no2} minLength="10" maxLength="13" onChange={this.phoneHandler} className="form-control" id="mobile2" />
                        </div>
                        <div className="col-md-9">
                            <label htmlFor="inputEmail4" className="form-label">* पत्ता   </label>
                            <ReactTransliterate value={this.state.sbgr_address} renderComponent={(props) => <textarea {...props} />} id="sbgr_address" maxLength="30" onChange={this.addressHandler} className="form-control" placeholder="थोडक्यात पत्ता टाकावा " />
                        </div>
                        <div className="col-12">

                            {this.state.btn_show ? <button type="submit" className="btn btn-primary" onClick={this.submitClick}>Save & Add More ▶️</button> : null}

                            <br></br>  <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;


                            {this.state.update_btn ? <button type="submit" className="btn btn-primary" onClick={this.updateClick}>Update ▶️</button> : null}
                        </div>
                        <hr></hr>

                        <ContactinfoList editshow={(id) => this.showedit(id)} deleteshow={(id, count) => this.deleteshow(id, count)} sbg_list={this.state.sbg_list} />

                        <div className="col-12">
                            {this.state.next_btn ? <button type="submit" className="btn btn-primary" onClick={this.nextClick}>Save & Continue ▶️</button> : null}
                        </div>
                    </form>
                </div>
            </>

        )
    }
}

export default ContactInfo
